import PerformanceNetworkViewQuery from '@jira/admin-pages__performance/src/__generated__/PerformanceNetworkViewQuery.graphql';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';

export const PerformanceMonitorDashboardEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForInteraction(
			() =>
				import(
					/* webpackChunkName: "async-system-performance-dashboard", jiraSpaEntry: "async-system-performance-dashboard" */ '@atlassian/jira-spa-apps-admin-pages-performance-dashboard'
				),
		),
		getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => {
			return {
				queries: {
					performanceNetworkQuery: {
						parameters: PerformanceNetworkViewQuery,
						variables: {
							cloudId: tenantContext.cloudId,
							startDate: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
							endDate: new Date().toISOString(),
							granularity: 'DAY',
						},
						fetchPolicy: 'store-or-network',
					},
				},
			};
		},
	},
	topNavigationMenuId: MENU_ID.SETTINGS,
});
